<div *ngIf="isSending" class="loader-overlay">
  <div class="spinner"></div>
</div>

<!-- feedback.component.html -->
<div *ngIf="showPopup" class="feedback-backdrop">
  <div
    class="feedback-modal"
    role="dialog"
    aria-modal="true"
    aria-labelledby="modal-headline"
  >
    <div class="feedback-content">
      <div class="feedback-header">
        <div class="feedback-icon">
          <span class="material-icons">add_comment</span>
        </div>
        <h3 class="feedback-title" id="modal-headline">Feedback</h3>
      </div>
      <div class="feedback-body">
        <form [formGroup]="feedbackForm" (ngSubmit)="onSubmit()">
          <div class="form-group">
            <label for="feedback">Feedback</label>
            <textarea
              id="feedback"
              formControlName="feedback"
              rows="6"
              placeholder="Help us improve this site by reporting any and all issues experienced and providing feedback on them"
            ></textarea>
            <p
              class="error-message"
              *ngIf="
                feedbackForm.get('feedback')!.invalid &&
                (feedbackForm.get('feedback')!.dirty ||
                  feedbackForm.get('feedback')!.touched)
              "
            >
              <span *ngIf="feedbackForm.get('feedback')!.hasError('required')">
                Feedback is required.
              </span>
              <span *ngIf="feedbackForm.get('feedback')!.hasError('maxWords')">
                Feedback must be 50 words or less (currently:
                {{
                  feedbackForm.get("feedback")!.errors?.maxWords.actual
                }}
                words).
              </span>
            </p>
          </div>
          <!-- <div class="form-group">
            <label for="landLine">Landline Number</label>
            <input id="landLine" formControlName="landLine" placeholder="0242 123 123" />
          </div> -->
          <div class="form-group">
            <label for="name">Name</label>
            <input id="name" formControlName="name" placeholder="John Doe" />
            <p
              class="error-message"
              *ngIf="
                feedbackForm.get('name')!.invalid &&
                (feedbackForm.get('name')!.dirty ||
                  feedbackForm.get('name')!.touched)
              "
            >
              <span> Your name is required. </span>
            </p>
          </div>

          <div class="form-group">
            <label for="email">Email</label>
            <input
              id="email"
              formControlName="email"
              placeholder="johndoe@something.com"
              type="email"
            />
            <p
              class="error-message"
              *ngIf="
                feedbackForm.get('email')!.invalid &&
                (feedbackForm.get('email')!.dirty ||
                  feedbackForm.get('email')!.touched)
              "
            >
              <span> Your email is required. </span>
            </p>
          </div>

          <div class="form-group">
            <label for="cellNumber">Mobile Number</label>
            <input
              id="cellNumber"
              formControlName="cellNumber"
              placeholder="+263 7xx xxx xxx"
            />
            <p
              class="error-message"
              *ngIf="
                feedbackForm.get('cellNumber')!.invalid &&
                (feedbackForm.get('cellNumber')!.dirty ||
                  feedbackForm.get('cellNumber')!.touched)
              "
            >
              <span> Your mobile number is required. </span>
            </p>
          </div>

          <div class="form-actions">
            <button type="button" class="btn-cancel" (click)="onCancelClick()">
              Cancel
            </button>
            <button class="btn-submit" [disabled]="feedbackForm.invalid">
              Submit
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>

<!-- Feedback here -->

<button (click)="onButtonClick()" *ngIf="!showPopup" class="feedback-btn">
  <div class="feedback-btn-icon">
    <span class="material-icons">add_comment</span>
  </div>
  <span>Feedback</span>
</button>



